<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- side -->
    <a-layout-sider
      :trigger="null"
      collapsible
      v-model="collapsed"
      width="256"
      style="position: fixed;top:0;left:0;height: 100%;"
    >
      <div class="logo">
        <img src="../assets/logo.png" style="height:100%;">
        <span class="slide-logo-title" v-show="!collapsed">睿吃餐厅</span>
      </div>
      <a-menu theme="dark" mode="inline" :defaultSelectedKeys="selectedMenuKeys">
        <template v-for="item in slideMenus">
          <template v-if="item.child">
            <a-sub-menu :key="item.key">
              <span slot="title">
                <rc-icon :type="item.iconType"/>
                <span>{{item.name}}</span>
              </span>
              <a-menu-item v-for="cItem in item.child" :key="cItem.key">
                <router-link :to="cItem.path">
                  <span>{{cItem.name}}</span>
                </router-link>
              </a-menu-item>
            </a-sub-menu>
          </template>
          <template v-else>
            <a-menu-item :key="item.key">
              <router-link :to="item.path">
                <rc-icon :type="item.iconType"/>
                <span>{{item.name}}</span>
              </router-link>
            </a-menu-item>
          </template>
        </template>
      </a-menu>
    </a-layout-sider>
    <a-layout :style="layoutContentStyle()">
      <!-- header -->
      <a-layout-header
        :class="['ant-header-fixedHeader', collapsed?'ant-header-side-closed':'ant-header-side-open']"
      >
        <div class="top-nav-header-index">
          <div class="header-index-wide">
            <div class="header-index-left">
              <a-icon
                class="trigger"
                :type="collapsed ? 'menu-unfold' : 'menu-fold'"
                @click="()=> collapsed = !collapsed"
              />
            </div>
            <user-menu class="header-index-right"></user-menu>
          </div>
        </div>
      </a-layout-header>
      <!-- content -->
      <a-layout-content style="padding: 10px;">
        <div
          class="user-layout-content"
          :style="{margin: '64px 0px 0px 0px',  minHeight: '360px' }"
        >
          <transition name="slide">
            <router-view></router-view>
          </transition>
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import { asyncRouterMap } from '@/config/router.config'
import userMenu from '@/components/tools/userMenu'
import { Icon } from 'ant-design-vue'
const RCIcon = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1246502_fc8ocdr1kh7.js' // 在 iconfont.cn 上生成
})

export default {
  data () {
    return {
      collapsed: false,
      selectedMenuKeys: ['employee-manage'],
      slideMenus: []
    }
  },
  created () {
    // 渲染slideMenus
    let temp = asyncRouterMap[1].children
    temp.forEach(item => {
      // debugger
      if (item.iconType !== undefined) {
        this.slideMenus.push(item)
      }
    })
    // 渲染当前页tab
    let currentKey =
      this.$route.path.slice(1) === 'today-order'
        ? 'order-manage'
        : this.$route.path.slice(1)
    this.selectedMenuKeys[0] = currentKey
  },
  methods: {
    layoutContentStyle () {
      return {
        'padding-left': this.collapsed ? '80px' : '256px',
        'min-height': '100vh'
      }
    }
  },
  components: {
    userMenu,
    // eslint-disable-next-line vue/no-unused-components
    'rc-icon': RCIcon
  },
  watch: {
    $route (to, from) {
      // console.log(to, from)
      let currentKey =
        to.path.slice(1) === 'today-order' ? 'order-manage' : to.path.slice(1)
      this.selectedMenuKeys[0] = currentKey
    }
  }
}
</script>
<style lang="less" scoped>
@import url("../assets/less/global.less");
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
  .slide-logo-title {
    font-size: 16px;
    color: #229d49;
    line-height: 32px;
    margin-left: 10px;
  }
}

.header-menu {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
